import React, { useEffect, useState } from 'react';
import { withStyles } from "@material-ui/core/styles";
import axios from 'axios';

import i18n from '../i18n';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';

// import '../css/style.css';
import InternalComments from './InternalComments';

const styles = theme => ({
    cust: {
        paddingTop: '7px'
    }
});

const IndpCommentComponent = ({ element_id, element_type, jwt, user_id, user_name, api_url, api_origin }) => {

    const [agentList, setAgentList] = useState();
    const [elementData, setElementData] = useState();
    const [internalComments, setInternalComments] = useState();

    const getAgents = async () => {
    
        let agntData = await axios.get(api_url+'/admin/agents',
        {   
            headers: {
                "Accept": "application/json, text/javascript, */*; q=0.01",
                "Authorization": jwt
            }
        });
        
        if (agntData) {
            setAgentList(agntData.data.data);
        }
    }

    const getElementData = async () => {

        let newURL = '';
        if(element_type == 'document'){
            newURL = `${api_url}/admin/documents/${element_id}`;
        }else if(element_type == 'lists'){
            newURL = `${api_url}/admin/lists/${element_id}`;
        }else if(element_type == 'rma'){
            newURL = `${api_url}/admin/rmas/${element_id}`;
        }else if(element_type == 'target-discount'){
            newURL = `${api_url}/admin/target-discounts/${element_id}`;
        }else {
            newURL = `${api_url}/admin/internal-comments/${element_id}`;
        }

        let eleData = await axios.get(newURL,
        {
            headers: {
                "Accept": "application/json, text/javascript, */*; q=0.01",
                "Authorization": jwt
            }
        });
        
        if (eleData) {
            // console.log("jhduchd/ELEmmm: ", eleData.data.data.reference_id);
            setElementData(eleData.data.data);
        }
    }

    const getInternalComments = async () => {

        let newURL = '';
        if(element_type == 'document'){
            newURL = `${api_url}/admin/documents/${element_id}/internal-comments?include=reference`;
        }else if(element_type == 'lists'){
            newURL = `${api_url}/admin/lists/${element_id}/internal-comments?include=reference`;
        }else if(element_type == 'rma'){
            newURL = `${api_url}/admin/rmas/${element_id}/internal-comments?include=reference`;
        }else if(element_type == 'target-discount'){
            newURL = `${api_url}/admin/target-discounts/${element_id}/internal-comments?include=reference`;
        }else {
            newURL = `${api_url}/admin/internal-comments/${element_id}?include=reference`;
        }

        let docData = await axios.get(newURL,
        {
            headers: {
                "Accept": "application/json, text/javascript, */*; q=0.01",
                "Authorization": jwt
            }
        });
        
        if (docData) {
            setInternalComments(docData.data.data);
        }
    }

    useEffect(() => {
        getAgents();
        getElementData();
        getInternalComments();
    },[]);

    return(
        <InternalComments 
            jwt={jwt}
            user_id={user_id}
            api_origin={api_origin}
            api_url={api_url}
            user_name={user_name}
            agentList={agentList}
            element_id={element_id}
            elementData={elementData}
            element_type={element_type}
            internalComments={internalComments}
            getInternalComments={getInternalComments}
        />
    );
}

export default withStyles(styles)(withTranslation()(IndpCommentComponent));